/* Stable within one visit, renewed on a new page visit. No product records change. */
function wwPicksRank(id, seed) {
  let x = (Number(id) ^ seed) >>> 0;
  x = Math.imul(x ^ (x >>> 16), 0x45d9f3b);
  x = Math.imul(x ^ (x >>> 16), 0x45d9f3b);
  return (x ^ (x >>> 16)) >>> 0;
}
function wwPicksOrder(products, seed) {
  const unique = [...new Map(products.map(p => [String(p.id), p])).values()];
  const ranked = unique.sort((a, b) => wwPicksRank(a.id, seed) - wwPicksRank(b.id, seed));
  const ordered = [];
  // Mix categories where a catalogue contains several types, keeping available items first.
  for (const available of [true, false]) {
    const buckets = new Map();
    for (const p of ranked.filter(p => Boolean(p.available) === available)) {
      const key = p.kind === 'Watches' ? (p.gender || 'men') : p.kind;
      if (!buckets.has(key)) buckets.set(key, []);
      buckets.get(key).push(p);
    }
    const cycle = ['men', 'women', 'men', 'Bags', 'men', 'women', 'Wallets', 'men', 'Pens', 'women', 'Fragrances'];
    while ([...buckets.values()].some(list => list.length)) {
      let added = 0;
      for (const key of cycle) {
        const list = buckets.get(key);
        if (list?.length) { ordered.push(list.shift()); added++; }
      }
      if (!added) for (const list of buckets.values()) ordered.push(...list.splice(0));
    }
  }
  return ordered;
}
/* Browser */
(() => {
  'use strict';
  const ar = document.documentElement.lang.startsWith('ar');
  const label = ar ? 'مختاراتنا' : 'Our picks';
  const freshSeed = () => crypto.getRandomValues(new Uint32Array(1))[0];
  let seed = freshSeed(), mountNumber = 0;
  const cache = new Map(), mounts = new WeakMap(), shuffled = new WeakSet();
  const isPicks = () => !new URLSearchParams(location.search).get('sort_by') || ['manual', 'relevance'].includes(new URLSearchParams(location.search).get('sort_by'));
  function sourceURL(container) {
    const url = new URL(container?.dataset.wwPicksUrl || location.href, location.origin);
    url.hash = '';
    for (const key of ['page', 'section_id', 'sections', 'sort_by', 'ww_advanced']) url.searchParams.delete(key);
    url.searchParams.set('view', 'ww-picks-data');
    if (/\/search\/?$/.test(url.pathname)) url.searchParams.set('type', 'product');
    return url;
  }
  async function load(url) {
    const key = url.href;
    if (cache.has(key)) return cache.get(key);
    const pending = (async () => {
      const page = async n => {
        const next = new URL(url); next.searchParams.set('page', n);
        const response = await fetch(next, {credentials: 'same-origin', signal: AbortSignal.timeout(30000)});
        if (!response.ok) throw Error('catalog unavailable');
        const data = await response.json();
        if (!Array.isArray(data.products) || data.products.some(p => typeof p.html !== 'string' || p.html.includes('Liquid error'))) throw Error('invalid catalog');
        return data;
      };
      const first = await page(1), pages = [first];
      // Bounded concurrency avoids flooding the storefront on large catalogues.
      for (let n = 2; n <= first.pages; n += 3) {
        pages.push(...await Promise.all(Array.from({length: Math.min(3, first.pages - n + 1)}, (_, i) => page(n + i))));
      }
      const products = [...new Map(pages.flatMap(p => p.products).map(p => [String(p.id), p])).values()];
      if (products.length !== first.total) throw Error('incomplete catalog');
      return products;
    })();
    cache.set(key, pending);
    pending.catch(() => cache.delete(key));
    return pending;
  }
  function initCards() {
    window.T4SThemeSP?.reinitProductGridItem?.();
    window.lazySizesT4?.loader?.checkElems?.();
  }
  function updateLabel(container) {
    const section = container.closest('.shopify-section');
    const dropdown = section?.querySelector('.t4s-dropdown__sortby');
    if (!dropdown) return;
    const chosen = isPicks();
    if (chosen) {
      dropdown.querySelectorAll('[data-dropdown-open] span').forEach(span => span.textContent = label);
      dropdown.querySelectorAll('[data-sortby-item]').forEach(button => button.classList.toggle('is--selected', ['manual', 'relevance'].includes(button.dataset.value)));
    }
  }
  async function mount(container) {
    updateLabel(container);
    if (!isPicks()) { delete container.dataset.wwPicksState; return; }
    const grid = container.querySelector('[data-contentlm-replace].t4s-products');
    if (!grid || !grid.querySelector('.t4s-product')) return;
    const url = sourceURL(container), old = mounts.get(grid);
    if (old?.key === url.href && (old.loading || grid.querySelector('.t4s-product')?.dataset.wwPickBatch === old.token)) return;
    const state = {key: url.href, token: String(++mountNumber), loading: true}; mounts.set(grid, state);
    container.querySelectorAll('.ww-picks-toolbar, .ww-picks-more').forEach(el => el.remove());
    container.dataset.wwPicksState = 'loading';
    const toolbar = document.createElement('div'); toolbar.className = 'ww-picks-toolbar';
    const info = document.createElement('div'), title = document.createElement('strong'), count = document.createElement('span');
    title.textContent = label; count.setAttribute('role', 'status');
    count.textContent = ar ? 'نجهّز مختاراتك…' : 'Preparing your picks…';
    info.append(title, count); toolbar.append(info); grid.before(toolbar);
    try {
      const products = await load(url);
      if (!grid.isConnected || mounts.get(grid) !== state || sourceURL(container).href !== url.href || !isPicks()) { toolbar.remove(); return; }
      let ordered = wwPicksOrder(products, seed), shown = 0;
      const footer = document.createElement('div'); footer.className = 'ww-picks-more';
      const more = document.createElement('button'); more.type = 'button'; more.className = 'ww-button'; more.textContent = ar ? 'عرض المزيد' : 'View more';
      const progress = document.createElement('small'); footer.append(more, progress); grid.after(footer);
      const refresh = document.createElement('button'); refresh.type = 'button'; refresh.className = 'ww-picks-refresh'; refresh.textContent = ar ? 'تجديد المختارات ↻' : 'Refresh picks ↻'; toolbar.append(refresh);
      // Keep the native responsive columns and native product actions.
      grid.classList.remove('isotopet4s'); grid.removeAttribute('data-isotopet4s-js'); grid.style.height = '';
      grid.dataset.wwPicksGrid = ''; grid.replaceChildren();
      const append = () => {
        const batch = ordered.slice(shown, shown + 20);
        const template = document.createElement('template'); template.innerHTML = batch.map(p => p.html).join('');
        template.content.querySelectorAll('.t4s-product').forEach(card => card.dataset.wwPickBatch = state.token);
        grid.append(template.content); shown += batch.length;
        const text = ar ? `${shown} من ${ordered.length} منتج` : `${shown} of ${ordered.length} products`;
        count.textContent = text; progress.textContent = text; more.hidden = shown >= ordered.length;
        footer.hidden = shown >= ordered.length;
        container.dataset.wwPicksTotal = ordered.length; container.dataset.wwPicksShown = shown;
        initCards();
      };
      more.addEventListener('click', append);
      refresh.addEventListener('click', () => { seed = freshSeed(); ordered = wwPicksOrder(products, seed); shown = 0; grid.replaceChildren(); append(); });
      container.dataset.wwPicksState = 'ready'; append(); state.loading = false;
    } catch (error) {
      if (grid.isConnected && mounts.get(grid) === state) {
        delete container.dataset.wwPicksState;
        count.textContent = ar ? 'يمكنك متابعة التصفح، أو إعادة المحاولة.' : 'Continue browsing, or retry.';
        const retry = document.createElement('button'); retry.className = 'ww-picks-refresh'; retry.type = 'button'; retry.textContent = ar ? 'إعادة المحاولة' : 'Retry';
        retry.addEventListener('click', () => { mounts.delete(grid); toolbar.remove(); mount(container); }); toolbar.append(retry);
      }
    }
  }
  function shuffleRelated() {
    document.querySelectorAll('.id_product-recommendations .t4s-products').forEach(grid => {
      const parent = grid.querySelector('.flickityt4s-slider') || grid;
      const cards = [...parent.children].filter(el => el.matches('.t4s-product'));
      if (cards.length < 2 || shuffled.has(grid)) return;
      shuffled.add(grid);
      cards.sort((a, b) => wwPicksRank(JSON.parse(a.dataset.productOptions || '{}').id, seed) - wwPicksRank(JSON.parse(b.dataset.productOptions || '{}').id, seed));
      parent.append(...cards);
      if (grid.classList.contains('flickityt4s-enabled')) window.jQuery_T4NT?.(grid).flickityt4s('reloadCells');
      const caption = document.createElement('p'); caption.className = 'ww-picks-related-label'; caption.textContent = label; grid.before(caption);
    });
  }
  // Sort choices use ordinary URLs, preserving every active filter and resetting pagination.
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-sortby-item]');
    if (!button || !document.querySelector('[data-ww-catalog]')) return;
    event.preventDefault(); event.stopImmediatePropagation();
    const url = new URL(location.href); url.searchParams.delete('page');
    if (['manual', 'relevance'].includes(button.dataset.value)) url.searchParams.delete('sort_by');
    else url.searchParams.set('sort_by', button.dataset.value);
    location.assign(url.href);
  }, true);
  let timer;
  const scan = () => { document.querySelectorAll('[data-ww-catalog]').forEach(mount); shuffleRelated(); };
  const observer = new MutationObserver(() => { clearTimeout(timer); timer = setTimeout(scan, 100); });
  observer.observe(document.querySelector('main') || document.body, {childList: true, subtree: true});
  window.addEventListener('popstate', scan);
  scan();
})();
